export default class Acount {
  constructor(balance) {
    this.balance = balance;
  }
}
